/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var PanelAutoComplete = new Class({
    Extends:QuriobotElement,
    template: function(displayType){
        var base = {
          list:
            '<div class="panel--wrapper panel--autocomplete no--options" id="options__{{ eid }}">' +
            '   <div class="panel--main">' +
            '       <ul role="listbox" id="page__{{ eid }}">' +
            '       </ul>' +
            '   </div>' +
            '</div>' +
            '<div class="input--wrapper input--autocomplete isLoading" family="{{ key }}" id="{{ eid }}">' +
            '   <div class="input--inner">' +
            '       <div aria-label={{ title }} role="combobox" aria-expanded="false" aria-owns="page__{{ eid }}" class="input--content">' +
            '           <input autocomplete="off" aria-autocomplete="list" aria-controls="page__{{ eid }}" type="text" placeholder="{{ placeholder }}" class="data--wrapper" id="autoCompleteInput" />' +
            '       </div>' +
            '       <button type="button" type="submit" class="input--button"></button>' +
            '   </div>' +
            '</div>',

          tiles:
            '<div class="panel--wrapper panel--anchor isLoading" family="{{ key }}" id="{{ eid }}">' +
            '    <div class="panel--main">' +
            '        {{ anchor }}' +
            '        <div class="arrow"></div>' +
            '        <div class="redo--x"></div>' +
            '    </div>' +
            '</div>',
        }

        var options =
            '<div class="page--search">'+
            '    <div class="page--header">'+
            '        <h1>{{ anchor }}</h1>'+
            '        <div class="page--form">'+
            '            <input autocomplete="off" type="search" name="{{ _inputs.0_ }}" placeholder="{{ _placeholders.0_ }}"/>'+
            '            <button class="{{ _buttons.0_ }}">'+
            '                <span class="icon__search"></span>'+
            '                <span class="page--buttonText">'+
            '                    {{ _buttons.0_ }}'+
            '                </span>'+
            '            </button>'+
            '        </div>'+
            '    </div>'+
            '    <div class="page--body">'+
            '        <div class="page--options">'+
            '            <ul id="page__{{ eid }}">'+
            '                {% options %}'+
            '            </ul>'+
            '        </div>'+
            '    </div>'+
            '</div>';

        var location =
                    '<li role="option" autocomplete-id="{{ id }}" class="option google--location">'+
                    '    <span class="autocomplete--text">{{ description }}</span>'+
                    '</li>';

        var empty = '<li class="empty--result"><span>Your search has no results</span></li>';

        return {
                'base': base[displayType],
                'options': options,
                'empty': empty,
                'location': location,
            };
    },
    populate: function(optionsHTML, displayType){

        var base = this.template(displayType).base;

        Object.each(this.data, function(val, key){
            base = base.replace(new RegExp('{{\\s\*'+key+'\\s\*}}','g'), val);
        });

        if(displayType == 'tiles'){
            var options = this.template().options;
                Object.each(this.data, function(val, key){
                    options = options.replace(new RegExp('{{\\s\*'+key+'\\s\*}}','g'), val);
                }.bind(this));

                this.api.getData.inputs.each(function(name, key){
                    options = options.replace(new RegExp('{{\\s\*_inputs.'+key+'_\\s\*}}','g'),name);
                    options = options.replace(new RegExp('{{\\s\*_placeholders.'+key+'_\\s\*}}','g'),this.api.getData.placeholders[key]);
                    options = options.replace(new RegExp('{{\\s\*_buttons.'+key+'_\\s\*}}','g'),this.api.getData.buttons[key]);
                }.bind(this));

                options = options.replace(/\{\%\s*options\s*\%\}/g, optionsHTML);

            return {
                'anchor':base,
                'options':options
            }
        }else{
            return base.replace(/\{\%\s*options\s*\%\}/g, optionsHTML);
        }
    },
    populateOption: function(obj){
        var itemHTML = this.api.getData.itemTpl;

        if(obj){
            Object.each(obj,function(val, key){
                if(
                    this.api.getData.forceHTTPS === true &&
                    typeOf(val) == 'string'
                ){
                    val = val.replace(/^http:\/\//g,'https://');
                }
                itemHTML = itemHTML.replace(new RegExp('{{\\s\*'+key+'\\s\*}}','g'),val);
            }.bind(this));
        }else{
            itemHTML = '<li><div class="product--wrapper"><div class="product--description empty" style="text-align:center;">We couldn\'t find the product you where looking for..</div></div></li>';
        }

        return itemHTML;
    },
    populateOptions: function(options, append){
        var optionsHTML = '';
        var _e = this.template().empty;

        if(!options || !options.length){
            optionsHTML = _e;
        }else{
            options.each(function(obj){
                optionsHTML += this.populateOption(obj) + "\n";
            }.bind(this));
        }
        this.addToDom(optionsHTML, append);
    },
    paginationCurrent:0,
    paginationMax:null,
    isUpdating:false,
    autoCompleteInput:null,
    makeApiCall:function(newSearch){
        // fetch search params.

        if(!newSearch){
            if(this.isUpdating){
                return;
            }else{
                this.isUpdating = true;
            }
        }else{
            this.isUpdating = true;
        }

        var _p = (typeOf(this.api.putPagination) == 'object')? this.api.putPagination : false;
        var _d = Object.clone(this.api.putData);
        var _allow = true;

        _d[this.api.getData.inputs[0]]= (this.autoCompleteInput && this.autoCompleteInput.length > 1)? this.autoCompleteInput : null;

        if(_p){
            if(newSearch){
                this.paginationCurrent = 0;
            }

            if(this.paginationMax && this.paginationCurrent >= this.paginationMax){
                _allow = false;
                return;
            }

            _d[_p.offsetKey] = this.paginationCurrent;
            _d[_p.lengthKey] = _p.per;

            this.paginationCurrent = this.paginationCurrent + _p.per;
        }

        if(_allow){
            new Request({
                'url':this.api.putUrl,
                'method':this.api.putMethod,
                'type':this.api.putExpect,
                'data':_d,
                onComplete:function(resultData){
                    this.handleApiCall(resultData);
                }.bind(this),
                onError:function(error){
                    this.addToDom('error', false);
                }.bind(this)
            }).send();
        }

    },
    handleApiCall:function(resultData){
        var resultDataObj = (this.api.putExpect == 'JSON')?
            JSON.parse(resultData) :
            resultData;

        var list = resultDataObj[this.api.getData.listKey];
        var max = resultDataObj[this.api.getData.countKey];

        if(!this.paginationMax){
            this.paginationMax = max;
            this.populateOptions(list);
        }else{
            this.populateOptions(list, true);
        }
    },
    makeApiCall_single:function(id, singleCallback){
        var _p = (typeOf(this.api.putPagination) == 'object')? this.api.putPagination : false;
        var _d = Object.clone(this.api.putData);
            _d[this.api.getData.inputs[0]] = id;
            _d[_p.offsetKey] = 0;
            _d[_p.lengthKey] = 1;

        if(id){

            new Request({
                url: this.api.putUrl,
                method: this.api.putMethod,
                type: this.api.putExpect,
                data: _d,
                onComplete:function(result){
                    var resultDataObj = (this.api.putExpect == 'JSON')?
                        JSON.parse(result) :
                        result;

                    var item = resultDataObj[this.api.getData.listKey][0];
                    var htmlResult = new Element('div',{
                        'html': this.populateOption(item)
                    });

                    singleCallback(htmlResult);

                }.bind(this),
                onError:function(err){}.bind(this)
            }).send();
        }
    },
    emptyOptions: function(){
        this.page_options.set('html','');
    },
    addToDom: function(resultsData, update){
        this.isUpdating = false;
        if(!resultsData){
            this.makeApiCall();
            return;
        }
        if(!update){
            var htmlContent = this.populate(resultsData, this.api.getData.displayAs);
                switch(this.api.getData.displayAs){
                    case "tiles":
                        this.parent_after.appendHTML(htmlContent.anchor, 'before');
                        this.foldOut(htmlContent.options, true);
                        this.page_options = $('page__' + this.data.eid);
                        break;
                }
        }else{
            switch(this.api.getData.displayAs){
                case "tiles":
                    this.page_options.appendHTML(resultsData);
                    this.attach_options();
                    break;
            }
            return;
        }
        this.in();
    },
    show_autoCompleteOptions:function(){
        this.auto_options.removeClass('no--options');
        $$('.input--content').set('aria-expanded', true);
    },
    hide_autoCompleteOptions:function(){
        this.auto_options.addClass('no--options');
        $$('.input--content').set('aria-expanded', false);
    },
    attach: function(){
        if(this.api.getData.displayAs == 'tiles'){
            var _contentWrapper = this.foldOutHtml().getElements('.page--options')[0];
            if (!_contentWrapper) {
                return
            }

            _contentWrapper.addEvents({
                scroll:function(e){
                    var distScrolled = _contentWrapper.getScroll().y,
                        distToTop = _contentWrapper.getScrollSize().y - _contentWrapper.getSize().y;

                    if((distScrolled + 30) >= distToTop){
                        this.makeApiCall();
                    }
                }.bind(this)
            });

            var _searchWrapper = this.foldOutHtml().getElements('.page--form')[0];
            var _searchInput = _searchWrapper.getElements('input')[0];
            var _searchButton = _searchWrapper.getElements('button')[0];

            // remove header from foldout
            this.foldOutContainer().addClass('fold-out_type_no-header');

            var _searchTimer = null;
                _searchInput.addEvents({
                    keyup:function(e){
                        clearTimeout(_searchTimer);
                        if(e.key == 'enter'){
                            this.autoCompleteInput = _searchInput.get('value');
                            this.makeApiCall(true);
                            this.emptyOptions();
                        }else{
                            _searchTimer = setTimeout(function(){
                                this.autoCompleteInput = _searchInput.get('value');
                                this.makeApiCall(true);
                                this.emptyOptions();
                            }.bind(this),500);
                        }
                    }.bind(this),
                    click:function(){
                         _searchTimer = setTimeout(function(){
                                this.autoCompleteInput = _searchInput.get('value');
                                this.makeApiCall(true);
                                this.emptyOptions();
                            }.bind(this),500);
                    }.bind(this)
                });

                _searchButton.addEvents({
                    click:function(e){
                        clearTimeout(_searchTimer);
                        this.autoCompleteInput = _searchInput.get('value');
                        this.makeApiCall(true);
                        this.emptyOptions();
                    }.bind(this)
                });

            var _redo = this.element.getElements('.redo--x')[0];
                _redo.addEvents({
                    click:function(e){
                        if(this.foldOutOpen){
                            return;
                        }
                        if(e){
                            e.preventDefault();
                        }
                        this.element.removeClass('isAnswered');
                        this.foldOutContainer().addClass('fold-out_type_no-header');
                        this.redoCallback(this.data, this.element);
                        this.foldOut(false,true);
                    }.bind(this)
                });
        }
        this.attach_options();
    },
    attach_options:function(){
        if(this.page_options){
            var options = this.page_options.getElements('.option');
        }
        var optionClicked = false;
        options.each(function(obj, i){
            obj.removeEvents();
            obj.addEvents({
                click:function(e){
                    e.preventDefault();

                    if(!optionClicked){
                        optionClicked = true;
                        setTimeout(function(){
                            optionClicked = false;
                        },500);
                        this.selectedOption = obj.clone();
                        this.after();
                    }else{
                        return;
                    }
                }.bind(this)
            });
        }.bind(this));
    },
    handlePrefilled:function(savedData){
        if(!savedData){
            if(!this.data.savedValue.render){
                var answerData = {
                    'answer': {
                        'value' : this.data.savedValue.value,
                        'content' : this.data.savedValue.value,
                        'render' : false
                    }
                }
                this.handlePrefilled(answerData);
                return;
            }else{
                if(this.api.getData.displayAs == 'tiles'){
                    this.makeApiCall_single(this.data.savedValue.value, this.handlePrefilled.bind(this));
                }
                return;
            }
        }else{
            if(this.data.savedValue.render){
                this.selectedOption = savedData.getElements('li')[0];
                var answerData = {
                    'answer' : {
                        'value': this.data.savedValue.value,
                        'content': this.selectedOption.get('html'),
                        'render': 'product product--preset'
                    }
                }
            }else{
                var answerData = savedData;
            }

            this.answerCallback(this.data, answerData, true);
        }
    },
    after: function(){
        this.foldOutClose();
        this.element.addClass('isAnswered');

        if(this.api.getData.displayAs == 'tiles'){
            var answerData = {
                'answer': {
                    'value' : this.selectedOption.get('data-option-id'),
                    'content' : this.selectedOption.get('html'),
                    'render' : 'product'
                }
            }
        }

        this.answerCallback(this.data, answerData);
    }
});
